import config from "../config";
import {Util} from "baziigram";
import {dictionary} from "../constants"

export default client => {
    function call(userName,otp) {
        var body = {"userName": userName , "oTP": otp};
        return client.post(config.app.service.apiUrls.GameUserVerify, body ).then(resp => {

            if (resp.status && (resp.status === 200 || resp.status === 204))
              { setTimeout(()=>{ client.proccessQueue(resp.data.accessToken)},3000)
               return resp.data;
              }

            throw new Error(resp.message || dictionary.serverError[Util.getLanguage()]);
        });
    }

    return call;
};
